import React from "react";
import { StyledLoader } from "./styled";

function Loader() {
  return <StyledLoader />;
}

export default Loader;
